
import card from './components/card.vue'
import openbg from '@/assets/lalisai/popup-bg.png'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'

import { getExam, getview, save } from '@/api/jfhl.js'
import { addTaskSecond, endPanduan } from '@/api/lalisai'
export default {
directives: {
TransferDom
},
components: { card, XDialog, XButton },
name: 'list',
props: {},
data () {
return {
partyId: '1',
openbg: openbg,
active: 0,
partyid: this.$route.params.partyid,
paperInfoid: '',
lotid: '',
examList: '',
subjectid: [],
useroption: [],
multi: [],
btnPre: '上一题',
btnNext: '下一题',
btnFinal: '提交',
once: true,
showDialog: false,
showErrorList: false,
dialogType: '',
dialogText: '',
errorList: '',
rightnum: ''
}
},
created () {
endPanduan({
partyId: this.partyId
}).then(res => {
if (!res.obj) {
this.$router.push({ name: 'lalisaiIndex' })
this.$vux.toast.text('活动已结束')
} else {





this.view() 

}
})
},
mounted () {
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
watch: {
active (newValue, oldValue) {
if (newValue === this.examList.length - 1) {
this.btnNext = '提交'
} else {
this.btnNext = '下一题'
}
},
useroption (newValue, oldValue) {

this.useroption = newValue
console.log(this.useroption)
}
},
methods: {

view () {
getview({
id: this.partyid
}).then(res => {
this.paperInfoid = res.obj.paperid
this.lotid = res.obj.lotid
this.getExam()
})
},
getExam () {
getExam({
paperInfoid: this.paperInfoid,
openid: this.accountid
}).then(data => {
if (data.obj.ANSWERNUM <= 0) {
this.$vux.alert.show('您今天的答题机会已用完请下周再来')
setTimeout(() => {
this.$router.push({
name: 'lalisaiIndex'
})
}, 1000)
return false
}
this.examList = data.obj.SUBJECTLIST
data.obj.SUBJECTLIST.forEach(element => {
this.subjectid.push(element.SUBJECTID)
})
}).catch(e => {
this.$router.push({ name: 'lalisaiIndex' })
})
},
answerPre () {
this.active--
},

answerNext () {
if (this.active + 1 >= this.examList.length && this.useroption[this.active]) {
if (this.multi.length > 0) {
this.$set(
this.useroption,
this.useroption.length,
this.multi.join(',')
)
this.multi = []
}
console.log(this.useroption)
if (this.once) {
this.once = false
save({
paperInfoid: this.paperInfoid,
subjectid: this.subjectid.join(';'),
useroption: this.useroption.join(';'),
openid: this.accountid
}).then(data => {
this.once = true
if (data.obj.ISTRUE === 1) {
this.showDialog = true
this.dialogText = '恭喜您!<br>获得一次抽奖机会'
this.rightnum = this.examList.length
this.dialogType = 'success'
} else {
let wt = data.obj.ERRORLIST.length
this.showDialog = true
this.dialogText =
'答对' + (this.examList.length - wt) + '题，答错' + wt + '题'
this.errorList = data.obj.ERRORLIST
this.rightnum = this.examList.length - wt
this.dialogType = 'fail'
}
addTaskSecond({
accountid: this.accountid,
num: this.rightnum,
partyId: this.partyId
})
})
}
} else {
if (this.multi.length > 0) {
this.$set(
this.useroption,
this.useroption.length,
this.multi.join(',')
)
this.multi = []
}
if (!this.useroption[this.active]) {
console.log(this.active)
this.$vux.toast.text('请选择答案')
return false
}
this.active++
}
},
viewerrorlist () {
this.showDialog = false
this.showErrorList = true
},
goWrong () {
this.showErrorList = false
this.$router.push({
name: 'lalisaiIndex'
})
},
gotolottery () {
this.showDialog = false
this.$router.push({
name: 'lalisaiLottery',
params: { partyid: this.partyid, obj: '1' }
})
},
reload () {
this.$router.go(-1)
}
}
}
